import { setUpAPI, setUpAPIExchange } from "../Utils/api.utils";
import AUCTIONS_DATA from "./fake/auctions";
import { AUCTION_DEFAULTS } from "./fake/auction-default";
import TRADING_BOARD_DETAILS_DATA from "./fake/trading-board-details";
import MessageErrorTradingBoard from "../components/errorMessage/error-modal-tradiingBoard.component";

/*import { setUpAPI } from "../../Utils/api.utils";*/

export const fetchBids = async (auctionId) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "getBids",
      auction_id: auctionId,
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const fetchPrivateBids = async (auctionId) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "getBidsFollow",
      auction_id: auctionId,
    };
    const apiResponse = await setUpAPI("followingAuctionPrivate", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const GetHomeInfo = async (userId) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      cmd: "GetHomeInfo",
      userId: userId,
    };
    const apiResponse = await setUpAPI("mobileHome", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const fetchAuctions = async (userId) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const data = {
        action: "getAllAuctions",
        UserId: userId,
      };
      const apiResponse = await setUpAPI("DuthAuction", data, "POST", null);
      const dataRequest = await apiResponse.json();

      const response = dataRequest.reduce((acc, item) => {
        const symbol = AUCTIONS_DATA.find(
          (auction) => auction.symbolID == item.symbol && auction.isFromDB === undefined
        );
        const base = symbol || AUCTIONS_DATA[0];

        const exists = AUCTIONS_DATA.find(
          (auction) => auction.auctionID == item.auctionid
        );

        if (!exists) {
          const tempData = {
            ...base,
            ...item,
            auctionID: parseInt(item.auctionID),
          };
          acc.push(tempData);
        }

        return acc;
      }, []);

      resolve(response);
    } catch (error) {
      reject(`There was an error retrieving the data, please try again. Error: ${error}`);
    }
  });
};

export const fetchAuctionsProgress = async (userId,pageIndex,pageCount) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const data = {
        action: "getAllProgress",
        UserId: userId,
        pageIndex: pageIndex,
        pageCount: pageCount
      };
      const apiResponse = await setUpAPI("DuthAuction", data, "POST", null);
      const dataRequest = await apiResponse.json();

      const response = dataRequest.reduce((acc, item) => {
        const symbol = AUCTIONS_DATA.find(
          (auction) => auction.symbolID == item.symbol && auction.isFromDB === undefined
        );
        const base = symbol || AUCTIONS_DATA[0];

        const exists = AUCTIONS_DATA.find(
          (auction) => auction.auctionID == item.auctionid
        );

        if (!exists) {
          const tempData = {
            ...base,
            ...item,
            auctionID: parseInt(item.auctionID),
          };
          acc.push(tempData);
        }

        return acc;
      }, []);

      resolve(response);
    } catch (error) {
      reject(`There was an error retrieving the data, please try again. Error: ${error}`);
    }
  });
};

export const fetchAuctionsSchedule = async (userId,pageIndex,pageCount) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const data = {
        action: "getAllUpcoming",
        UserId: userId,
        pageIndex: pageIndex,
        pageCount: pageCount
      };
      const apiResponse = await setUpAPI("DuthAuction", data, "POST", null);
      const dataRequest = await apiResponse.json();

      const response = dataRequest.reduce((acc, item) => {
        const symbol = AUCTIONS_DATA.find(
          (auction) => auction.symbolID == item.symbol && auction.isFromDB === undefined
        );
        const base = symbol || AUCTIONS_DATA[0];

        const exists = AUCTIONS_DATA.find(
          (auction) => auction.auctionID == item.auctionid
        );

        if (!exists) {
          const tempData = {
            ...base,
            ...item,
            auctionID: parseInt(item.auctionID),
          };
          acc.push(tempData);
        }

        return acc;
      }, []);

      resolve(response);
    } catch (error) {
      reject(`There was an error retrieving the data, please try again. Error: ${error}`);
    }
  });
};

export const fetchPrivateAuctions = async (userId) => {
  return await new Promise(async (resolve, reject) => {
    const response = [];
    const data = {
      action: "getAllPrivateAuctions",
      user_id: userId,
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );
    const dataRequest = await apiResponse.json();
    dataRequest.map((item) => {
      var tempData = undefined;
      const symbol = AUCTIONS_DATA.filter(
        (auction) =>
          auction.symbolID == item.symbol && auction.isFromDB == undefined
      );

      if (symbol && symbol.length > 0) {
        tempData = Object.assign({}, symbol[0]);
      } else {
        tempData = Object.assign({}, AUCTIONS_DATA[0]);
      }

      const find = AUCTIONS_DATA.filter(
        (auction) => auction.auctionID == item.auctionid
      );

      if (find.length == 0) {
        tempData.status = item.status;
        tempData.title = item.title;
        tempData.imgSrc = item.imgSrc;
        tempData.videos = item.videos;
        tempData.startDate = item.startDate;
        tempData.minUnitPrice = item.minUnitPrice;
        tempData.comitted = item.comitted;
        tempData.endDate = item.endDate;
        tempData.startDateFormat = item.startDateFormat;
        tempData.endDateFormat = item.endDateFormat;
        tempData.endDate = item.endDate;

        tempData.description = item.description;
        tempData.start_price = item.start_price;
        tempData.minAuctionTarget = item.minAuctionTarget;
        tempData.units = item.units;
        tempData.auctionID = parseInt(item.auctionID);
        tempData.isFromDB = item.isFromDB;
        tempData.minimum_price = item.minimum_price;
        tempData.maximum_price = item.maximum_price;
        tempData.targetPricePerUnit = item.targetPricePerUnit;

        tempData.CurrentAuctionPrice = item.CurrentAuctionPrice;
        tempData.AverageBid = item.AverageBid;
        tempData.BidedUnits = item.BidedUnits;
        tempData.progress = item.progress;
        tempData.minimum_price_num = item.minimum_price_num;
        tempData.maximum_price_num = item.maximum_price_num;

        tempData.entryid = item.entryid;
        tempData.step = item.step;
        tempData.stepFormat = item.stepFormat;
        tempData.listingType = item.listingType;
        tempData.tracks = item.tracks;
        tempData.spotifyLink = item.spotifyLink;
        tempData.youtubeChannel = item.youtubeChannel;
        tempData.youtubeMonthlyListeners = item.youtubeMonthlyListeners;
        tempData.spotifyChannel = item.spotifyChannel;
        tempData.spotifyMonthlyListeners = item.spotifyMonthlyListeners;
        tempData.instagramChannel = item.instagramChannel;
        tempData.instagramMonthlyListeners = item.instagramMonthlyListeners;

        tempData.IsWatch = item.IsWatch;

        response.push(tempData);
      }

      return true;
    }); /*.catch(error => {
           
            reject(error);
        });*/
    if (response) {
      resolve(response);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const getAuctionDetails = async (auctionID, userId ,isOwnerOnly) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "getAuctionByIdNewWeb",
      auction_id: auctionID,
      userId: userId,
      isOwnerOnly:isOwnerOnly
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    var tempData = undefined;

    try {
      var item = await apiResponse.json();
      if (!Array.isArray(item)) {
        resolve(item); 
        return;
      }
      var itemfirst = item[0];

      if (itemfirst != undefined) {
        if (Array.isArray(itemfirst.genre)) {
          itemfirst.genreArray = itemfirst.genre;
        } else if (itemfirst.genre.startsWith("[")) {
          itemfirst.genreArray = JSON.parse(itemfirst.genre);
        } else if (itemfirst.genre != "") {
          itemfirst.genreArray = [itemfirst.genre];
        } else {
          itemfirst.genreArray = [];
        }
        const symbol = AUCTIONS_DATA.filter(
          (auction) => auction.symbolID == item.symbol && auction.isFromDB != 1
        );

        // if(symbol && symbol.length>0)
        // {
        //     tempData=Object.assign({}, symbol[0]);
        // }
        // else{

        // }

        tempData = Object.assign({}, AUCTIONS_DATA[2]);

        itemfirst.financials = tempData.financials;
        if (itemfirst.tracks) {
          itemfirst.tracks.forEach((item) => {
            item.trackScore = tempData.tracks[0].trackScore;
            item.socialMediaStatistics =
              tempData.tracks[0].socialMediaStatistics;
          });
        }

        var ntracks = tempData.rights.filter(
          (item) => item.title === "Number of tracks"
        );

        if (ntracks) {
          ntracks[0].description = itemfirst.tracks
            ? itemfirst.tracks.length
            : "0";
        }

        const { symbolType } = itemfirst;
        //itemfirst.mentions = tempData.mentions;
        tempData.rights.map((val) => {
          if (val.title == "Symbol type") {
            val.description = symbolType;
          }
          return val;
        });

        tempData = { ...tempData, ...itemfirst };

        resolve(tempData);
      } else {
        resolve({});
      }
    } catch (error) {
      reject(error);
    }

    /*if(item.imgSrc) {
            tempData.imgSrc = item.imgSrc;
        }
        if(item.listingGenre) {
            tempData.listingGenre = item.listingGenre;
        }

        if(item.symbolType) {
            tempData.symbolType = item.symbolType;
        }

        if(item.spotifyLink) {
            tempData.spotifyLink = item.spotifyLink;
        }

        if(item.symbol) {
            tempData.symbolID = item.symbol;
        }

        tempData.status=item.status;
        tempData.title=item.title;
        tempData.startDate=item.startDate;
        tempData.comitted=item.comitted;
        tempData.endDate=item.endDate;
        tempData.minUnitPrice=item.minUnitPrice;
        tempData.startDateFormat=item.startDateFormat;
        tempData.endDateFormat=item.endDateFormat;
        tempData.description=item.description;
        tempData.start_price=item.start_price;
        tempData.minAuctionTarget=item.minAuctionTarget;
        tempData.units=item.units;
        tempData.auctionID=item.auctionID;
        tempData.isFromDB=item.isFromDB;
        tempData.minimum_price=item.minimum_price;
        tempData.maximum_price=item.maximum_price;
        tempData.minimum_units=item.minimum_units;
        tempData.maximum_units=item.maximum_units;
        tempData.targetPricePerUnit=item.targetPricePerUnit;

        tempData.CurrentAuctionPrice=item.CurrentAuctionPrice;
        tempData.AverageBid=item.AverageBid;
        tempData.BidedUnits=item.BidedUnits;
        tempData.progress=item.progress;
        tempData.minimum_price_num=item.minimum_price_num;
        tempData.maximum_price_num=item.maximum_price_num;
        tempData.entryid=item.entryid;
        tempData.step=item.step;
        tempData.stepFormat=item.stepFormat;

        if(item.videos){
            tempData.videos = item.videos;
        }

        if(item.rights) {
            tempData.rights = item.rights;
        }

        if(item.tracks) {
            tempData.tracks = item.tracks;
        }
        if(tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }*/
  });
};

export const getPublicAuctionDetails = async (auctionID) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "getAuctionByIdNewWeb",
      auction_id: auctionID
    };
    const apiResponse = await setUpAPI("Public-DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    var tempData = undefined;

    try {
      var item = await apiResponse.json();
      var itemfirst = item[0];

      if (itemfirst != undefined) {
        if (Array.isArray(itemfirst.genre)) {
          itemfirst.genreArray = itemfirst.genre;
        } else if (itemfirst.genre.startsWith("[")) {
          itemfirst.genreArray = JSON.parse(itemfirst.genre);
        } else if (itemfirst.genre != "") {
          itemfirst.genreArray = [itemfirst.genre];
        } else {
          itemfirst.genreArray = [];
        }
        const symbol = AUCTIONS_DATA.filter(
          (auction) => auction.symbolID == item.symbol && auction.isFromDB != 1
        );

        // if(symbol && symbol.length>0)
        // {
        //     tempData=Object.assign({}, symbol[0]);
        // }
        // else{

        // }

        tempData = Object.assign({}, AUCTIONS_DATA[2]);

        itemfirst.financials = tempData.financials;
        if (itemfirst.tracks) {
          itemfirst.tracks.forEach((item) => {
            item.trackScore = tempData.tracks[0].trackScore;
            item.socialMediaStatistics =
              tempData.tracks[0].socialMediaStatistics;
          });
        }

        var ntracks = tempData.rights.filter(
          (item) => item.title === "Number of tracks"
        );

        if (ntracks) {
          ntracks[0].description = itemfirst.tracks
            ? itemfirst.tracks.length
            : "0";
        }

        const { symbolType } = itemfirst;
        //itemfirst.mentions = tempData.mentions;
        tempData.rights.map((val) => {
          if (val.title == "Symbol type") {
            val.description = symbolType;
          }
          return val;
        });

        tempData = { ...tempData, ...itemfirst };

        resolve(tempData);
      } else {
        resolve({});
      }
    } catch (error) {
      reject(error);
    }

    /*if(item.imgSrc) {
            tempData.imgSrc = item.imgSrc;
        }
        if(item.listingGenre) {
            tempData.listingGenre = item.listingGenre;
        }

        if(item.symbolType) {
            tempData.symbolType = item.symbolType;
        }

        if(item.spotifyLink) {
            tempData.spotifyLink = item.spotifyLink;
        }

        if(item.symbol) {
            tempData.symbolID = item.symbol;
        }

        tempData.status=item.status;
        tempData.title=item.title;
        tempData.startDate=item.startDate;
        tempData.comitted=item.comitted;
        tempData.endDate=item.endDate;
        tempData.minUnitPrice=item.minUnitPrice;
        tempData.startDateFormat=item.startDateFormat;
        tempData.endDateFormat=item.endDateFormat;
        tempData.description=item.description;
        tempData.start_price=item.start_price;
        tempData.minAuctionTarget=item.minAuctionTarget;
        tempData.units=item.units;
        tempData.auctionID=item.auctionID;
        tempData.isFromDB=item.isFromDB;
        tempData.minimum_price=item.minimum_price;
        tempData.maximum_price=item.maximum_price;
        tempData.minimum_units=item.minimum_units;
        tempData.maximum_units=item.maximum_units;
        tempData.targetPricePerUnit=item.targetPricePerUnit;

        tempData.CurrentAuctionPrice=item.CurrentAuctionPrice;
        tempData.AverageBid=item.AverageBid;
        tempData.BidedUnits=item.BidedUnits;
        tempData.progress=item.progress;
        tempData.minimum_price_num=item.minimum_price_num;
        tempData.maximum_price_num=item.maximum_price_num;
        tempData.entryid=item.entryid;
        tempData.step=item.step;
        tempData.stepFormat=item.stepFormat;

        if(item.videos){
            tempData.videos = item.videos;
        }

        if(item.rights) {
            tempData.rights = item.rights;
        }

        if(item.tracks) {
            tempData.tracks = item.tracks;
        }
        if(tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }*/
  });
};

export const getAuctionPreviewById = async (auctionID) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "getAuctionPreviewById",
      auction_id: auctionID,
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );
    var tempData = undefined;

    var item = await apiResponse.json();
    const symbol = AUCTIONS_DATA.filter(
      (auction) => auction.symbolID == item.symbol && auction.isFromDB != 1
    );

    if (symbol && symbol.length > 0) {
      tempData = Object.assign({}, symbol[0]);
    } else {
      tempData = Object.assign({}, AUCTIONS_DATA[0]);
    }
    tempData.status = item.status;
    tempData.title = item.title;
    tempData.startDate = item.startDate;
    tempData.endDate = item.endDate;
    tempData.description = item.description;
    tempData.start_price = item.start_price;
    tempData.minAuctionTarget = item.minAuctionTarget;
    tempData.units = item.units;
    tempData.auctionID = parseInt(item.auctionID);
    tempData.isFromDB = item.isFromDB;
    tempData.minimum_price = item.minimum_price;
    tempData.maximum_price = item.maximum_price;
    tempData.minimum_units = item.minimum_units;
    tempData.maximum_units = item.maximum_units;
    tempData.targetPricePerUnit = item.targetPricePerUnit;

    tempData.CurrentAuctionPrice = item.CurrentAuctionPrice;
    tempData.AverageBid = item.AverageBid;
    tempData.BidedUnits = item.BidedUnits;
    tempData.progress = item.progress;
    tempData.minimum_price_num = item.minimum_price_num;
    tempData.maximum_price_num = item.maximum_price_num;

    if (tempData) {
      resolve(tempData);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const getAuctionDefaultValues = async () => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      action: "GetAuctionDefault",
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    var response = [];

    const resText = await apiResponse.text();

    if (resText && resText !== "[resultData]") {
      response = JSON.parse(resText);
    }

    var tempData = undefined;

    tempData = { ...AUCTION_DEFAULTS, ...response };

    if (tempData) {
      resolve(tempData);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const updateNotifyoptions = async (auctionDetails) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      cmd: "iEventsNotification_Save",
      ...auctionDetails,
    };
    const apiResponse = await setUpAPI(
      "Notifications",
      data,
      "POST",
      null
    ).catch((error) => {
      reject(error);
    });

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const deleteAccount = async (email, token) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      cmd: "mDeleteAccount_AddSession",
      sessionToken: token,
      email: email,
    };
    const apiResponse = await setUpAPI(
      "DeleteAccount",
      data,
      "POST",
      null
    ).catch((error) => {
      reject(error);
    });

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const getNotifyoptions = async (UserId) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      cmd: "iEventsNotification_GetNotificationById",
      UserId: UserId,
    };

    try {
      const apiResponse = await setUpAPI("Notifications", data, "POST", null);

      if (apiResponse && apiResponse.ok) {
        const responseText = await apiResponse.text();
        console.log("Response Text (non-JSON):", responseText);

        try {
          // Envolver la respuesta en un array manualmente y luego parsearla
          const responseData = JSON.parse(`[${responseText}]`);
          console.log("Parsed Response Data:", responseData);
          resolve(responseData);
        } catch (parseError) {
          reject("Error parsing JSON:", parseError);
        }
      } else {
        reject(`There was an error retrieving the data, please try again.`);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const getGlobalBidFee = async () => {
  try {
    const response = await setUpAPIExchange(
      "wallet/v1/wallet/auction/get-bid-fee",
      null,
      "GET",
      null
    );

    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
  } catch (error) {
    return console.error(error);
  }
};

export const getSingleUpcomingAuction = async () => {
  return await new Promise((resolve, reject) => {
    const response = AUCTIONS_DATA;

    if (response) {
      const nextAuction = AUCTIONS_DATA.sort(
        (a, b) => b.startDate - a.startDate
      ).filter((auction) => auction.status === "scheduled");
      if (nextAuction) {
        resolve(nextAuction[0]);
      } else {
        reject("There are no upcoming auctions");
      }
    } else {
      reject("There are no upcoming auctions");
    }
  });
};

export const getTradingBoardData = async (auctionID) => {
  try {
    const data = {
      action: "getAuctionByIdNewWeb",
      auction_id: auctionID,
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null);

    if (!apiResponse.ok) {
      throw new Error(`API request failed with status ${apiResponse.status}`);
    }
    const itemText = await apiResponse.text();
    const item = JSON.parse(itemText);
    const itemfirst = item[0];
    if (!itemfirst) {
      return "open Message";
      //alert('Auction not found');
      throw new Error("Auction not found");
    }
    if (itemfirst.genre) {
      if (Array.isArray(itemfirst.genre)) {
        itemfirst.genreArray = itemfirst.genre;
      } else if (itemfirst.genre.startsWith("[")) {
        itemfirst.genreArray = JSON.parse(itemfirst.genre);
      } else {
        itemfirst.genreArray = [itemfirst.genre];
      }
    } else {
      itemfirst.genreArray = [];
    }
    return itemfirst;
  } catch (error) {
    console.error("Error retrieving trading board data:", error);
    return null;
  }
};

export const auction_Add = async (userID, listing) => {
  const data = {
    action: "addAuction",
    user_id: userID,
    ...listing,
  };

  const response = await setUpAPI("DuthAuction", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const auction_Save = async (userID, listing) => {
  const data = {
    action: "saveAuction",
    user_id: userID,
    ...listing,
  };

  const response = await setUpAPI("DuthAuction", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const sumbitFounds = async (value) => {
  return await new Promise(async (resolve, reject) => {
    let monthAndYear = value.ccExpDate.split("/", 2);
    const data = {
      cmd: "insertAddFundsPayment",
      CreditCardNumber: value.ccNumber,
      ccType: value.ccType,
      ccCardHolder: value.ccCardHolder,
      /*CreditCardCvv: value.CreditCardCvv,*/
      CreditCardExpiryMonth: monthAndYear[0],
      CreditCardExpiryYear: monthAndYear[1],
      Amount: value.customAmount,
      UserId: value.UserId,
    };

    const response = await setUpAPI("mPayment", data, "POST", null).catch(
      (error) => {
        return error;
      }
    );

    if (response) {
      resolve(response);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
};

export const auction_Stop = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_CloseAuction",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};
export const private_auction_Stop = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_CloseAuction",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mPrivateAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const auction_Accept = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_AcceptOffer",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};
export const private_auction_Accept = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_AcceptOffer",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mPrivateAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const auction_Reject = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_RejectAuction",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};
export const private_auction_Reject = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_RejectAuction",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mPrivateAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const auction_Extend = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_ExtendAuction",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const Private_auction_Extend = async (userID, auctionID) => {
  const data = {
    cmd: "iAuctions_ExtendAuctionPrivate",
    UserId: userID,
    id: auctionID,
  };

  const response = await setUpAPI("mPrivateAuctionStatus", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const bid_Add = async (
  userID,
  auction_id,
  token,
  sessionId,
  listing
) => {
  const data = {
    action: "addBid",
    user_id: userID,
    auction_id: auction_id,
    antierLoginToken: token,
    sessionId: sessionId,
    ...listing,
  };

  const response = await setUpAPI("DuthAuction", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const Private_bid_Add = async (
  userID,
  auction_id,
  token,
  sessionId,
  listing
) => {
  const data = {
    action: "addBidPrivateFollow",
    user_id: userID,
    auction_id: auction_id,
    antierLoginToken: token,
    sessionId: sessionId,
    ...listing,
  };

  const response = await setUpAPI("followingAuctionPrivate", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const getAnalytics = async (auction_id) => {
  if (!auction_id) {
    return;
  }
  const data = {
    cmd: "iBids_GetAnalyticsReferrals",
    auction_id: auction_id,
  };

  const response = await setUpAPI("mBids", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const preview_auction = async (userID, listing) => {
  const data = {
    action: "previewAuction",
    user_id: userID,
    ...listing,
  };

  const response = await setUpAPI("DuthAuction", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );

  return response.json();
};

export const getGraphs = async (id) => {
  const data = {
    cmd: "iBids_GetAllBids",
    auction_id: id,
  };
  const response = await setUpAPI("mBids", data, "POST", null).catch(
    (error) => {
      return error;
    }
  );
  return response.json();
};

// export const albumTest = async () => {
//     const response = await fetch('http://ec2-54-157-216-255.compute-1.amazonaws.com/api/albumTest').catch(err => {return err});
//     const body = await response.json();
//     return body.obj;
// }

// export const artistTest = async () => {
//     const response = await fetch('http://ec2-54-157-216-255.compute-1.amazonaws.com/api/artistTest').catch(err => {return err});
//     const body = await response.json();
//     const src = body.obj.cm_statistics;
//     const result = {
//         description: body.obj.description,

//     }

//     return result;
// }

export const updateFavorite = async (userId, auctionId) => {
  try {
    const response = await setUpAPI(
      "WatchList",
      {
        cmd: "UpdateFavorite",
        auction_id: auctionId,
        user_id: userId,
      },
      "POST",
      null
    );
    return await response.json();
  } catch (error) {
    return console.log(error, "error");
  }
};

export const savePrivateAuction = async (payload) => {
  try {
    const saveResponse = await setUpAPI(
      "followingAuctionPrivate",
      payload,
      "POST",
      null
    );
    console.log({ saveResponse });
    return saveResponse;
  } catch (error) { }
};

export const savePublicAuction = async (payload) => {
  try {
    const saveResponse = await setUpAPI(
      "followingAuctionPublic",
      payload,
      "POST",
      null
    );
    return saveResponse;
  } catch (error) { }
};

/**
 * @function getAuctionById
 * @description Retrieves an auction by its ID
 * @param {number} auctionId - the ID of the auction to retrieve
 * @returns {Promise<object>} - the auction object
 */
export const getAuctionById = async (auctionId) => {
  try {
    const auction = await setUpAPI(
      "api/DuthAuction",
      {
        action: "getAuctionByIdNew",
        auction_id: auctionId,
      },
      "POST",
      null
    );
    return auction?.json();
  } catch (error) { }
};

export const getSymbolDetails = async (name) => {
  try {
    const auction = await setUpAPIExchange(
      `wallet/v1/wallet/auction/get-symbols-details?name=${name}`,
      null,
      "GET",
      null
    );
    return auction?.json();
  } catch (error) {}
};

export const updateUnits = async (entryId,units,percentrage,signValue) => {
  return await new Promise(async (resolve, reject) => {
    const data = {
      cmd: "iAsset_UpdateUnits",
      entryid: entryId,
      Leftunits: units,
      LeftPercentage: percentrage,
      signValue:signValue
    };
    const apiResponse = await setUpAPI("DuthAuction", data, "POST", null).catch(
      (error) => {
        reject(error);
      }
    );

    if (apiResponse) {
      resolve(apiResponse);
    } else {
      reject(`There was an error retrieving the data, please try again.`);
    }
  });
}

export const getAuctionByEntryId = async (auctionId, entryId) => {
  try {
    const auction = await setUpAPI(
      "api/mAuctions",
      {
        cmd: "iAsset_GetAuctionByEntryAndAuctionId",
        id: auctionId,
        Entryid: entryId
      },
      "POST",
      null
    );
    return auction?.json();
  } catch (error) { }
};